import axios from 'axios';
import {API_URL_BASE, DEFAULT_LANGUAGE, FILTERS_SLUG} from './constants';

export async function getFiltersApi (lng: string = DEFAULT_LANGUAGE) {
    return axios(`${API_URL_BASE}${lng}/${FILTERS_SLUG}`);
}